import React from "react";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import _ from "lodash";
import { FormattedMessage } from "react-intl";

import { Info } from "components/Icons";
import Button from "components/Button";
import Select from "components/Select";
import RangeDatepicker from "components/RangeDatepicker";
import CorneredCard from "components/CorneredCard";
import ExportReport from "./partials/ExportReport";
import { getReports, getAreaalReport } from "./actions";
import FilterGenerator from "helpers/filter";
import { downloadFile } from "helpers/download";
import DeliveriesModal from "./partials/DeliveriesModal";

import "./style.scss";
import AreaStatementModal from "./partials/AreaStatementModal";
import { modalTypes } from "constants/index";

interface IProps {
  roles: string[];
  intl: any;
  roleIds: any[];
  currentCustomer: any;
}

interface IState {
  exportBlockVisibility: boolean[];
  filterBtw: any;
  filterIcp: any;
  isLoading: any;
  isDeliveryModalOpen: boolean;
  isAreaStatementModalOpen: boolean;
}

class MyReports extends React.Component<IProps, IState> {
  constructor(props) {
    super(props);

    this.state = {
      exportBlockVisibility: [false, false, false],
      isLoading: {},
      filterBtw: {
        date: {},
      },
      filterIcp: {
        date: {},
      },
      isDeliveryModalOpen: false,
      isAreaStatementModalOpen: false,
    };
  }

  private changeBlockVisibility = (index) => {
    const exportBlockVisibility = this.state.exportBlockVisibility.slice();
    exportBlockVisibility[index] = !exportBlockVisibility[index];
    this.setState({
      exportBlockVisibility,
    });
  };

  private handleFilterChange = (objName, value, name) => {
    const filter = _.cloneDeep(this.state[objName]);
    _.set(filter, name, value);
    return filter;
  };

  private downloadFile = (format, type, filter?) => {
    this.handleLoader(type);
    const Q = new FilterGenerator();
    Q.and("TypeId", type, "string");
    Q.and("FormatId", format, "string");
    let filterString = Q.query;

    if (filter) {
      filterString = `${filterString} and ${filter}`;
    }

    if (type !== modalTypes.areaStatement) {
      getReports(filterString)
        .then((file) => {
          this.handleDeliveryModal(false);
          this.handleLoader(type);
          downloadFile(
            file,
            `${type}.${format === "Excel" ? "xlsx" : _.toLower(format)}`
          );
        })
        .catch((err) => {
          this.handleDeliveryModal(false);
          this.handleLoader(type);
        });
    }
    if (type === modalTypes.areaStatement) {
      getAreaalReport(filterString)
        .then((file) => {
          this.handleAreaStatementModal(false);
          this.handleLoader(type);
          downloadFile(
            file,
            `${type}.${format === "Excel" ? "xlsx" : _.toLower(format)}`
          );
        })
        .catch((err) => {
          this.handleAreaStatementModal(false);
          this.handleLoader(type);
        });
    }
  };

  private handleLoader = (name) => {
    const isLoading = this.state.isLoading;
    isLoading[name] = !isLoading[name];
    this.setState({ isLoading });
  };

  private handleDeliveryModal = (isDeliveryModalOpen) => {
    this.setState({ isDeliveryModalOpen });
  };

  private handleAreaStatementModal = (isAreaStatementModalOpen) => {
    this.setState({ isAreaStatementModalOpen });
  };

  private generateFilter = (format, type, filter) => {
    const Q = new FilterGenerator();
    Q.and("Soort", filter.type, "select");
    filter.date.from = filter.date.from || new Date("January 1 1970");
    filter.date.to = filter.date.to || new Date();
    Q.and("FromDate", filter.date.from, "date");
    Q.and("TillDate", filter.date.to, "date");

    this.downloadFile(format, type, Q.query);
  };

  public render() {
    const {
      exportBlockVisibility,
      filterBtw,
      filterIcp,
      isLoading,
      isDeliveryModalOpen,
      isAreaStatementModalOpen,
    } = this.state;
    const { roles, intl, roleIds, currentCustomer } = this.props;
    const reportsRoles = [
      {
        value: "Alle",
        label: intl.formatMessage({ id: "ALL" }),
      },
      ...roleIds
        .filter((r) => r.value !== "Supplier")
        .map(({ label }) => ({ label, value: label })),
    ];

    return (
      <div id="my-reports-page">
        <FormattedMessage id="MY_REPORTS" tagName="h1" />
        {_.includes(roles, "Financieel") && (
          <div className="container">
            <CorneredCard size="big" color="yellow">
              <div className="header flex-box">
                <FormattedMessage id="REPORTS_VAT" tagName="h3" />
              </div>
              <div className="mt-20">
                <Select
                  options={[
                    {
                      value: "OMZET",
                      label: intl.formatMessage({ id: "INVOICES_DATE" }),
                    },
                    {
                      value: "BETAALDATUM",
                      label: intl.formatMessage({ id: "PAYMENT_DATE" }),
                    },
                  ]}
                  onChange={(value) =>
                    this.setState({
                      filterBtw: this.handleFilterChange(
                        "filterBtw",
                        value,
                        "type"
                      ),
                    })
                  }
                  selectedOption={filterBtw.type}
                  className="min-width-select-forms muted-color"
                />
              </div>
              <div className="card-row flex-box">
                <RangeDatepicker
                  name="date"
                  value={filterBtw.date}
                  handleRangeChange={(value, name) =>
                    this.setState({
                      filterBtw: this.handleFilterChange(
                        "filterBtw",
                        value,
                        name
                      ),
                    })
                  }
                  kind="yellow"
                />
              </div>
              <Button
                id="download-reports-vat"
                className="animate-bg bg-yellow"
                fullWidth
                onClick={() => {
                  !isLoading.BTWOverzicht &&
                    this.generateFilter("PDF", "BTWOverzicht", filterBtw);
                }}
                disabled={
                  _.isEmpty(filterBtw.date) ||
                  _.isEmpty(filterBtw.type) ||
                  isLoading.BTWOverzicht
                }
                isLoading={isLoading.BTWOverzicht}
              >
                {isLoading.BTWOverzicht
                  ? "DOWNLOAD_LOADING"
                  : "REPORTS_SHOW_VAT"}
              </Button>
            </CorneredCard>

            <CorneredCard size="big" color="yellow">
              <div className="header flex-box">
                <FormattedMessage id="REPORTS_ICP" tagName="h3" />
              </div>
              <div className="card-row">
                <div className="card-row-header">
                  <FormattedMessage id="INVOICES_DATE" />
                </div>
                <RangeDatepicker
                  name="date"
                  value={filterIcp.date}
                  handleRangeChange={(value, name) =>
                    this.setState({
                      filterIcp: this.handleFilterChange(
                        "filterIcp",
                        value,
                        name
                      ),
                    })
                  }
                  kind="yellow"
                />
              </div>
              <div className="ict-button">
                <Button
                  id="download-reports-icp"
                  className="animate-bg bg-yellow"
                  fullWidth
                  onClick={() => {
                    !isLoading.ICPAangifte && this.changeBlockVisibility(0);
                  }}
                  disabled={_.isEmpty(filterIcp.date) || isLoading.ICPAangifte}
                  isLoading={isLoading.ICPAangifte}
                >
                  {isLoading.ICPAangifte
                    ? "DOWNLOAD_LOADING"
                    : "REPORTS_SHOW_ICP"}
                </Button>
                <ExportReport
                  id="download-reports-icp"
                  visible={exportBlockVisibility[0]}
                  clickedOutside={() => this.changeBlockVisibility(0)}
                  downloadFile={(format) => {
                    this.generateFilter(format, "ICPAangifte", filterIcp);
                    this.changeBlockVisibility(0);
                  }}
                />
              </div>
            </CorneredCard>
          </div>
        )}

        <div className="container">
          {_.includes(roles, "Financieel") && (
            <CorneredCard size="medium" color="alice">
              <div className="card-row flex-box">
                <div className="flex-box">
                  <FormattedMessage
                    id="REPORTS_INVOICED_DELIVERY"
                    tagName="h3"
                  />
                </div>
                <Button onClick={() => this.handleDeliveryModal(true)}>
                  SHOW
                </Button>
              </div>
            </CorneredCard>
          )}

          {_.includes(roles, "KPB_Documenten") && (
            <CorneredCard size="medium" color="alice">
              <div className="card-row flex-box">
                <div className="flex-box">
                  <FormattedMessage id="REPORTS_DELIVERED" tagName="h3" />
                </div>
                <Button
                  onClick={() =>
                    !isLoading.GeleverdePartijen &&
                    this.changeBlockVisibility(1)
                  }
                  isLoading={isLoading.GeleverdePartijen}
                  disabled={isLoading.GeleverdePartijen}
                >
                  {isLoading.GeleverdePartijen ? "LOADING" : "SHOW"}
                </Button>
              </div>
              <ExportReport
                id="download-reports-delivered"
                visible={exportBlockVisibility[1]}
                clickedOutside={() => this.changeBlockVisibility(1)}
                downloadFile={(format) => {
                  this.downloadFile(
                    format === "Excel" ? "CSV" : format,
                    "GeleverdePartijen"
                  );
                  this.changeBlockVisibility(1);
                }}
              />
            </CorneredCard>
          )}
        </div>

        {_.includes(roles, "KPB_Documenten") && (
          <div className="container">
            <CorneredCard size="medium" color="alice">
              <div className="card-row flex-box">
                <div className="flex-box">
                  <FormattedMessage id="REPORTS_READY" tagName="h3" />
                  <Info className="info" />
                  <div className="info-message">
                    <FormattedMessage id="REPORTS_INFO" />
                  </div>
                </div>
                <Button
                  onClick={() =>
                    !isLoading.AfroepPartijen && this.changeBlockVisibility(2)
                  }
                  isLoading={isLoading.AfroepPartijen}
                  disabled={isLoading.AfroepPartijen}
                >
                  {isLoading.AfroepPartijen ? "LOADING" : "SHOW"}
                </Button>
              </div>
              <ExportReport
                id="download-reports-ready"
                visible={exportBlockVisibility[2]}
                clickedOutside={() => this.changeBlockVisibility(2)}
                downloadFile={(format) => {
                  this.downloadFile(
                    format === "Excel" ? "CSV" : format,
                    "AfroepPartijen"
                  );
                  this.changeBlockVisibility(2);
                }}
              />
            </CorneredCard>

            <CorneredCard size="medium" color="alice">
              <div className="card-row flex-box">
                <div className="flex-box">
                  <FormattedMessage id="REPORTS_TULIPS" tagName="h3" />
                </div>
                <Button
                  id="download-reports-tulips-pdf"
                  onClick={() =>
                    !isLoading.GStadiumTulpen &&
                    this.downloadFile("PDF", "GStadiumTulpen")
                  }
                  isLoading={isLoading.GStadiumTulpen}
                  disabled={isLoading.GStadiumTulpen}
                >
                  {isLoading.GStadiumTulpen ? "LOADING" : "SHOW"}
                </Button>
              </div>
            </CorneredCard>
          </div>
        )}

        <div className="container">
          {_.includes(roles, "Financieel") && (
            <CorneredCard size="medium" color="alice" className="half-card">
              <div className="card-row flex-box">
                <div className="flex-box">
                  <FormattedMessage id="REPORTS_AREA_STATEMENT" tagName="h3" />
                </div>
                <Button onClick={() => this.handleAreaStatementModal(true)}>
                  SHOW
                </Button>
              </div>
            </CorneredCard>
          )}
        </div>

        <DeliveriesModal
          visible={isDeliveryModalOpen}
          onCloseModal={() => this.handleDeliveryModal(false)}
          isLoading={isLoading.Leveringen}
          downloadFile={this.downloadFile}
          roleIds={reportsRoles}
        />
        <AreaStatementModal
          visible={isAreaStatementModalOpen}
          onCloseModal={() => this.handleAreaStatementModal(false)}
          isLoading={isLoading.Areaalopgaven}
          downloadFile={this.downloadFile}
          roleIds={reportsRoles}
          currentCustomer={currentCustomer}
        />
      </div>
    );
  }
}

export default connect((state) => ({
  roles: state.app.roles,
  roleIds: state.app.roleIds,
  currentCustomer: state.app.currentCustomer,
}))(injectIntl(MyReports));
